module.exports = __webpack_public_path__ + "static/media/undraw-authentication-fsn-5.f27e89f2.svg";